export default "__VITE_ASSET__80cb1a6f__"